module.exports = __webpack_public_path__ + "img/7_4.6d4089d8.png";